import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";

export default function FeaturedCard({ article }) {
  if (!article) return null;
  return (
    <div className="relative h-full overflow-hidden rounded-2xl border border-primary/25 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent p-6 sm:p-8">
      <div className="absolute -right-24 -bottom-24 w-80 h-80 rounded-full bg-primary/10 blur-3xl pointer-events-none" />
      <div className="relative flex flex-col md:flex-row gap-6 items-start md:items-center h-full">
        <div className="flex-1 min-w-0">
          <div className="inline-flex items-center gap-1.5 text-primary text-[12px] font-semibold uppercase tracking-wider">
            <Sparkles className="w-3.5 h-3.5" /> {article.label}
          </div>
          <h2 className="mt-2 text-[22px] sm:text-[26px] leading-tight font-semibold tracking-tight text-foreground max-w-2xl">
            {article.title}
          </h2>
          {article.button_enabled !== false && (
            <a href={article.url || "#"} className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-4 py-2 text-[13.5px] font-semibold hover:bg-primary/90 transition-colors">
              {article.cta} <ArrowRight className="w-4 h-4" />
            </a>
          )}
        </div>
        {/* Decorative device mock */}
        <div className="relative shrink-0 hidden md:block">
          <div className="flex items-end gap-2">
            <div className="w-16 h-24 rounded-lg bg-card border border-border shadow-sm" />
            <div className="w-40 h-28 rounded-lg bg-card border border-border shadow-md relative">
              <div className="absolute inset-2 rounded-md bg-primary/10" />
              <div className="absolute inset-x-3 top-3 h-2 rounded bg-primary/40" />
              <div className="absolute inset-x-3 top-7 h-2 rounded bg-primary/25" />
              <div className="absolute inset-x-3 bottom-3 h-2 rounded bg-primary/25" />
            </div>
            <div className="w-20 h-32 rounded-lg bg-card border border-border shadow-sm relative">
              <div className="absolute inset-2 rounded bg-primary/10" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
